import { request } from '../../utility/services/request';
import { Service } from '../base';
import axios from 'axios';
import objectToFormData from '../../utility/Utils';

//get all permissions categories

class ReportsService {
	baseUrl = '/reportes';
	requestPrefixId = null;
	constructor(baseUrl, requestPrefixId = null) {
		this.baseUrl = baseUrl;
		this.requestPrefixId = requestPrefixId;
	}

	getReport = ({ reportType, ...data }) => {
		return request(
			'GET',
			// eslint-disable-next-line no-invalid-this
			`${this.baseUrl}/${reportType}?page=${data?.page || ''}
                ${data.per_page ? `&per_page=${data.per_page}` : ''}
				${data.orderBy ? `&orderBy=${data.orderBy}` : ''}
				${data.order ? `&order=${data.order}` : ''}
				${data.params ? `&params=${JSON.stringify(data.params)}` : ''}
			`
		);
	};

	getUpdatesByFichaId = (
		id,
		params = {
			page: null,
			per_page: '',
			orderBy: '',
			order: '',
			params: ''
		}
	) => {
		return request(
			'GET',
			// eslint-disable-next-line no-invalid-this
			`${this.baseUrl}/updates/${id}?page=${params?.page || ''}
				${params.per_page ? `&per_page=${params.per_page}` : ''}
				${params.orderBy ? `&orderBy=${params.orderBy}` : ''}
				${params.order ? `&order=${params.order}` : ''}
				${params.params ? `&params=${JSON.stringify(params.params)}` : ''}
			`
		);
	};
}

export default ReportsService;
